module.exports = __webpack_public_path__ + "img/svg2.dcc5775a.svg";